// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"UserProfileHeader-mainTitle"};